module.exports = __webpack_public_path__ + "img/Weapon_270.a00389b9.png";